export default __webpack_public_path__ + "static/media/CameraUberlandia.psd.c38738a9.png";